export default __webpack_public_path__ + "static/media/cartproductimg.eec326ea.png";